import React, { useState } from 'react';
import { Modal, Button, List, Message, useToaster, Loader } from 'rsuite';
import authFetch from '../../helpers/authFetch';

const MoveDeckToFolderModal = ({ open, onClose, deck, folders = [], onMoved }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const toaster = useToaster();
  const isInFolder = deck?.folder_id != null;

  const handleMoveDeck = async (folderId) => {
    setLoading(true);
    setError('');
    try {
      const response = await authFetch(`/collections/${deck.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ folder_id: folderId }),
      });

      if (response.ok) {
        const updated = await response.json();
        const message = folderId === null ? 'Deck removed from folder' : 'Deck moved successfully';
        toaster.push(
          <Message type="success" showIcon closable>
            {message}
          </Message>,
          { placement: 'topCenter', duration: 2000 }
        );
        if (onMoved) {
          onMoved(updated);
        }
        onClose();
      } else {
        setError('Failed to move deck');
      }
    } catch (err) {
      setError('Unable to connect to server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} size="sm">
      <Modal.Header>
        <Modal.Title>{isInFolder ? 'Move or Remove' : 'Move'} "{deck?.name}"</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Message type="error" showIcon style={{ marginBottom: 16 }}>
            {error}
          </Message>
        )}

        <div style={{ marginBottom: 16 }}>
          <h6>Select a destination:</h6>
          {loading ? (
            <Loader content="Moving..." />
          ) : (
            <>
              <List bordered size="sm" style={{ marginBottom: 12 }}>
                {isInFolder && (
                  <List.Item
                    style={{ padding: 12, cursor: 'pointer' }}
                    onClick={() => handleMoveDeck(null)}
                  >
                    ✕ Remove from Folder
                  </List.Item>
                )}
                {folders.map(folder => (
                  <List.Item
                    key={folder.id}
                    style={{ padding: 12, cursor: 'pointer' }}
                    onClick={() => handleMoveDeck(folder.id)}
                  >
                    📁 {folder.name}
                  </List.Item>
                ))}
              </List>
              {folders.length === 0 && (
                <p style={{ color: '#999', fontSize: 12 }}>
                  No folders available. Create one in Manage Folders.
                </p>
              )}
            </>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} appearance="subtle">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MoveDeckToFolderModal;
